/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { HubbleShipmentFiltersQuery } from "./HubbleShipmentFiltersQuery";
import {
  HubbleShipmentFiltersQueryFromJSON,
  HubbleShipmentFiltersQueryFromJSONTyped,
  HubbleShipmentFiltersQueryToJSON,
  HubbleShipmentFiltersQueryToJSONTyped,
} from "./HubbleShipmentFiltersQuery";
import type { AllShipmentsSortDirection } from "./AllShipmentsSortDirection";
import {
  AllShipmentsSortDirectionFromJSON,
  AllShipmentsSortDirectionFromJSONTyped,
  AllShipmentsSortDirectionToJSON,
  AllShipmentsSortDirectionToJSONTyped,
} from "./AllShipmentsSortDirection";

/**
 *
 * @export
 * @interface AllShipmentsSearchRequest
 */
export interface AllShipmentsSearchRequest {
  /**
   *
   * @type {HubbleShipmentFiltersQuery}
   * @memberof AllShipmentsSearchRequest
   */
  query: HubbleShipmentFiltersQuery;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsSearchRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsSearchRequest
   */
  pageSize: number;
  /**
   *
   * @type {string}
   * @memberof AllShipmentsSearchRequest
   */
  sortKey?: string | null;
  /**
   *
   * @type {AllShipmentsSortDirection}
   * @memberof AllShipmentsSearchRequest
   */
  sortDirection: AllShipmentsSortDirection;
}

/**
 * Check if a given object implements the AllShipmentsSearchRequest interface.
 */
export function instanceOfAllShipmentsSearchRequest(
  value: object,
): value is AllShipmentsSearchRequest {
  if (!("query" in value) || value["query"] === undefined) return false;
  if (!("page" in value) || value["page"] === undefined) return false;
  if (!("pageSize" in value) || value["pageSize"] === undefined) return false;
  if (!("sortDirection" in value) || value["sortDirection"] === undefined)
    return false;
  return true;
}

export function AllShipmentsSearchRequestFromJSON(
  json: any,
): AllShipmentsSearchRequest {
  return AllShipmentsSearchRequestFromJSONTyped(json, false);
}

export function AllShipmentsSearchRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsSearchRequest {
  if (json == null) {
    return json;
  }
  return {
    query: HubbleShipmentFiltersQueryFromJSON(json["query"]),
    page: json["page"],
    pageSize: json["pageSize"],
    sortKey: json["sortKey"] == null ? undefined : json["sortKey"],
    sortDirection: AllShipmentsSortDirectionFromJSON(json["sortDirection"]),
  };
}

export function AllShipmentsSearchRequestToJSON(
  json: any,
): AllShipmentsSearchRequest {
  return AllShipmentsSearchRequestToJSONTyped(json, false);
}

export function AllShipmentsSearchRequestToJSONTyped(
  value?: AllShipmentsSearchRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    query: HubbleShipmentFiltersQueryToJSON(value["query"]),
    page: value["page"],
    pageSize: value["pageSize"],
    sortKey: value["sortKey"],
    sortDirection: AllShipmentsSortDirectionToJSON(value["sortDirection"]),
  };
}
